import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

export const ErrorText = styled.p`
  font-size: 20px;
  font-weight: 700;
  color: ${(props) => props?.theme?.main?.color?.red?.color};
  text-align: center;
  max-width: 250px;
  margin-top: 16px;
`;
